export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5389.5b010275.jpg";